module.exports = __webpack_public_path__ + "static/img/nodata.65c70a40.png";